export const chartColors = [
  '#1ab394',
  '#1c84c6',
  '#7b70ef',
  '#f8ac59',
  '#0acf97',
  '#fcdebd',
  '#23c6c8',
  '#ed5565',
  '#ddedf6',
  '#daf8ef',
  '#def6f7',
  '#fef3e6',
  '#fce6e8',
  '#ebeafd',
  '#fbfbfd',
  '#ced4da',
  '#a3e1d4',
  '#a4cee8',
  '#9decd5',
  '#a7e8e9',
  '#f8bbc1',
  '#cac6f9',
];
